import { Link, useNavigate } from "react-router-dom";
import { LogOut, Shield } from "lucide-react";
import { logout } from "@/lib/authApi";
import { ADMIN } from "@/constants/testIds/admin";

export default function AdminHeader({ user }) {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await logout();
        } catch (_) {
            // Even if the server call fails, behave as logged-out client-side
        }
        navigate("/admin/login", { replace: true });
    };

    return (
        <header className="border-b border-slate-200 bg-white sticky top-0 z-30">
            <div className="ihx-container flex items-center justify-between h-[64px]">
                <Link to="/admin/applications" className="flex items-center gap-3">
                    <span className="w-8 h-8 rounded-full bg-[#0F172A] text-white grid place-items-center">
                        <Shield size={14} strokeWidth={1.6} />
                    </span>
                    <div className="leading-tight">
                        <div className="font-serif text-[15px] text-[#0F172A]">
                            Clinic Admin
                        </div>
                        <div className="text-[10.5px] tracking-[0.22em] uppercase text-slate-500">
                            Dr. Ishani Hanspal · Internal
                        </div>
                    </div>
                </Link>

                <div className="flex items-center gap-5">
                    {user && (
                        <div className="hidden md:flex items-center gap-3">
                            {user.picture ? (
                                <img
                                    src={user.picture}
                                    alt=""
                                    referrerPolicy="no-referrer"
                                    className="w-8 h-8 rounded-full object-cover"
                                />
                            ) : (
                                <span className="w-8 h-8 rounded-full bg-[#F8FAFC] border border-slate-200 grid place-items-center font-serif text-[13px] text-[#0F172A]">
                                    {(user.name || user.email || "?").charAt(0).toUpperCase()}
                                </span>
                            )}
                            <div className="leading-tight">
                                <div className="text-[13.5px] text-[#0F172A]">
                                    {user.name || user.email}
                                </div>
                                <div className="text-[11px] text-slate-500">
                                    {user.email}
                                </div>
                            </div>
                        </div>
                    )}
                    <button
                        type="button"
                        data-testid={ADMIN.logoutBtn}
                        onClick={handleLogout}
                        className="ihx-btn-secondary !p-0 !pb-1"
                    >
                        <LogOut size={14} strokeWidth={1.6} /> Sign out
                    </button>
                </div>
            </div>
        </header>
    );
}
